export default {
  listaConselhos: [],
  conselho: {
    id: null,
    descricao: '',
    sigla: '',
    ativo: true,
  },
}
